import { z } from 'zod';
import { idSchema, ratioSchema, signedRatioSchema, timestampSchema } from './common.js';
// --- Catégories : le plan de charges ---------------------------------------------------
export const CATEGORY_DIRECTIONS = ['income', 'expense'];
export const categoryInputSchema = z.object({
    /** Identifiant stable, en minuscules : `property-tax`. Ne change jamais. */
    code: z.string().regex(/^[a-z][a-z0-9]*(-[a-z0-9]+)*$/, 'Minuscules, chiffres et tirets'),
    label: z.string().trim().min(1).max(120),
    direction: z.enum(CATEGORY_DIRECTIONS),
});
/** Le code et le sens ne se modifient pas : des écritures s'y rattacheront. */
export const categoryUpdateSchema = z
    .object({
    label: categoryInputSchema.shape.label,
    isActive: z.boolean(),
})
    .partial()
    .refine((value) => Object.keys(value).length > 0, { message: 'Aucun champ à modifier' });
export const categorySchema = categoryInputSchema.extend({
    id: idSchema,
    isActive: z.boolean(),
    createdAt: timestampSchema,
});
// --- Hypothèses globales du moteur ------------------------------------------------------
/** Même liste que `TaxResidency` dans `@app/finance`, dont ce paquet ne dépend pas. */
export const TAX_RESIDENCIES = ['resident-fr', 'non-resident-eea', 'non-resident-other'];
/**
 * Jeu d'hypothèses du moteur `mmi-2026` (feuille `Hypothèses` du classeur MMI).
 * L'inflation et la croissance des prix peuvent être négatives ; les autres taux vont de 0 à 100 %.
 */
export const assumptionsInputSchema = z.object({
    taxResidency: z.enum(TAX_RESIDENCIES),
    acquisitionYear: z.number().int().min(2000).max(2100),
    inflation: signedRatioSchema,
    housingPriceGrowth: signedRatioSchema,
    personalTaxRate: ratioSchema,
    socialContributionRate: ratioSchema,
    capitalGainsTaxRate: ratioSchema,
    buildingDepreciationYears: z.number().int().min(1).max(100),
    furnitureDepreciationYears: z.number().int().min(1).max(100),
    landShare: ratioSchema,
});
export const assumptionsSchema = assumptionsInputSchema.extend({
    id: idSchema,
    createdAt: timestampSchema,
});
//# sourceMappingURL=reference.js.map